import { render } from "./VoicesView.vue?vue&type=template&id=38fd24ee"
import script from "./VoicesView.vue?vue&type=script&lang=js"
export * from "./VoicesView.vue?vue&type=script&lang=js"

import "./VoicesView.vue?vue&type=style&index=0&id=38fd24ee&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__